<template>
  <div>

    <CustomModal 
    :open="open_edit"
    :title="$_('customer_edit').toUpperCase()"
    :size="'lg'"
    :keepratio="true"
    @close-modal="open_edit = false">
      <template slot="modal_content">
        <CustomerAddress :mode="'sample'" :pnocl="Number(getCustomer)" />
      </template>
    </CustomModal>

    <CustomModal 
      :title="$_('customer_select').toUpperCase()"
      :open="open_cli"
      @close-modal="open_cli = false">
      <template slot="modal_content">
        <CustomerList @load-customer="vSelect($event.customer)"></CustomerList>
      </template>
    </CustomModal>

    <div class="grid-row">
      <div class="c-12">
        <div class="customer-block">
          <div class="form-field">
            <label>{{$_('customer_number')}} *</label>
            <div class="autocomplete">
              <input type="text" :value="customer_id" @dblclick="open_cli = true" @click="autocomplete_open = !autocomplete_open" :placeholder="$_('customer_code')" @input="vSearch($event.target.value)" />
              <div class="autocomplete-list" v-if="this.autocomplete_open">
                <li v-for="(cst, index) in customer" :key="index" @click="vSelect(cst)">
                  {{cst.TLIBCLI}}
                </li>
              </div>
            </div>
          </div>
          <div class="form-field">
            <label>{{$_('company')}}</label>
            <input type="text" v-model="customer_libelle"  disabled />
          </div>
          <div class="form-field" v-if="getCustomer !== 0">
            <label>&nbsp;</label>
            <span @click="open_edit = true" class="btn">{{$_('select_your_delivery_address')}}</span>
          </div>
        </div>
      </div>
    </div>


    <div class="customer-block-info" v-if="getCustomer !== 0">
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
            <span><strong>{{$_('last_name')}}:</strong> {{customer_info.TLIBCLI}}</span>
            <span><strong>{{$_('city')}}:</strong> {{customer_info.TVILLE}}</span>
            <span><strong>{{$_('country')}}:</strong> {{customer_info.TLPAYS}}</span>
            <span><strong>{{$_('actif')}}:</strong> {{customer_info.TACTIF === 0 ? 'Non': 'Oui'}}</span>
            <span><strong>{{$_('currency')}}:</strong> {{customer_info.TCDEV}}</span>
            <span><strong>{{$_('turnover_limit')}} {{customer_info.TCAN1_ANNEE}}:</strong> {{customer_info.TCAN1}} {{customer_info.TCDEV}}</span>
        </div>
         <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <span><strong>{{$_('turnover_limit')}} {{customer_info.TCAN_ANNEE}}:</strong> {{customer_info.TCAN}} {{customer_info.TCDEV}}</span>
          <span><strong>{{$_('category')}}:</strong> {{customer_info.TLIB_CATCLI}}</span>
          <span><strong>{{$_('commercial_assistant')}}:</strong> {{customer_info.TLIB_AC}}</span>
          <span><strong>{{$_('sales_assistant')}}:</strong> {{customer_info.TLIB_ADV}}</span>
          <span><strong>{{$_('responsible_business')}}:</strong> {{customer_info.TLIB_CDA}}</span>
          <span><strong>{{$_('sales_manager')}}:</strong> {{customer_info.TLIB_RDV}}</span>
        </div>
      </div>
    </div>

    <div class="delivery-block-info" v-if="this.$store.getters['echantillon/get_header'].tadr1l !== ''">
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <h2>{{$_('delivery_address')}}</h2>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <span><strong>{{$_('delivery_address_1')}}:</strong>{{this.$store.getters['echantillon/get_header'].tadr1l}}</span>
          <span><strong>{{$_('delivery_address_2')}}:</strong>{{this.$store.getters['echantillon/get_header'].tadr2l}}</span>
          <span><strong>{{$_('delivery_address_3')}}:</strong>{{this.$store.getters['echantillon/get_header'].tadr3l}}</span>
          <span><strong>{{$_('delivery_postal_code')}}:</strong>{{this.$store.getters['echantillon/get_header'].tcpostl}}</span>
          <span><strong>{{$_('delivery_city')}}:</strong>{{this.$store.getters['echantillon/get_header'].tvillel}}</span>
          <span><strong>{{$_('delivery_country')}}:</strong>{{this.$store.getters['echantillon/get_header'].tlpaysl}}</span>
          <span><strong>{{$_('delivery_district')}}:</strong>{{this.$store.getters['echantillon/get_header'].tlprovl}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import CustomModal from '@/common/components/widget/Modal/CustomModal';
import CustomerAddress from '@/modules/client/components/CustomerAddress';
import CustomerList from "@/modules/client/components/CustomerList";

import customerService from '@/modules/client/services/customerService'

export default {
  name:'FormCustomerSelect',
  components: {
    CustomModal,
    CustomerAddress,
    CustomerList
  },
  data() {
    return {
      open_edit: false,
      open_cli: false,
      company: '',
      timeout_id: 0,
      customer: [],
      autocomplete_open: false,
      customer_libelle: '',
      customer_id: '',
      customer_info: Object
    }
  },
  computed: {
    getCustomer() {
      return this.$store.getters['echantillon/get_tncli'];
    }
  },
  methods: {
    vSearch(value) {

      clearInterval(this.timeout_id);

      this.timeout_id = setTimeout(() => {
        return customerService.getCustomer({
          poffset: 0, 
          plimit: 999999,
          fncli: value,
          fnom: '',
          fville: '',
          fcpays: ''
          
        }).then(res => {
          if(res.data.DS_O !== undefined) {
            this.customer = res.data.DS_O.OUT
            this.autocomplete_open = true;
          }
        });
      }, 1000);
    },
    vSelect(customer) {
      console.error(customer);

      this.$store.dispatch('echantillon/SET_HEADER', {key: 'tncli', value: customer.TNCLI});
      this.autocomplete_open = false
      this.open_cli = false
      this.customer_libelle = customer.TLIBCLI;
      this.customer_id = customer.TNCLI;
      this.customer_info = customer

      customerService.getCustomerAddress('echantillon', customer.TNCLI)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(addr => {
            if(addr.TADR_DEFAUT === 'O') {
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr1l', value: addr.TADR1 });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr2l', value: addr.TADR2 });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tadr3l', value: addr.TADR3 });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpostl', value: addr.TCPOST });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tvillel', value: addr.TVILLE });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcpaysl', value: addr.TCPAYS });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tcprovl', value: addr.TCPROV });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tlpaysl', value: addr.TLPAYS });
              this.$store.dispatch("echantillon/SET_HEADER", { key: 'tlprovl', value: addr.TLPROV });
            }
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.customer-block {
  display: flex;
}
.customer-block .form-field {
  margin-right: 20px;
}
.autocomplete {
  position: relative;
}
.autocomplete-list {
  padding: 0px;
  position: absolute;
  background-color: #fff;
  border-left: solid 1px #e9e9e9;
  border-right: solid 1px #e9e9e9;
  border-bottom: solid 1px #e9e9e9;
  width: 100%;
}
.autocomplete-list li {
  list-style-type: none;
  padding: 10px;
  font-size: var(--fz-md);
}
.autocomplete-list li:hover {
  cursor: pointer;
}
.customer-block-info span,
 .delivery-block-info span{
  display: block;
  border-bottom: solid 1px #e9e9e9;
  padding: 10px;
  margin-bottom: 10px;
}
.customer-block-info span strong,
.delivery-block-info span strong {
  width: 200px;
  display: inline-block;
}
.delivery-block-info span {
  display: block;
}
</style>